import { JobWorkspaceIcon } from "./icons";
import { AmountRow, StatusPill, WorkspaceCard } from "./ui";

/**
 * Financial summary and approval for one job.
 * @param {{ view: object }} props
 * @returns {JSX.Element}
 */
export function FinancialSummary({ view }) {
  const approved = view.approval.status === "approved";
  const rejected = view.approval.status === "rejected";

  return (
    <div className="flex flex-col gap-5">
      <WorkspaceCard className="flex flex-col gap-5 p-5">
        <div className="flex items-center justify-between">
          <h2 className="text-[15px] font-semibold leading-normal text-[#202b33]">
            Financial summary
          </h2>
          <JobWorkspaceIcon name="receiptText" />
        </div>
        <div className="flex flex-col gap-[7px] rounded-[6px] bg-[#f7f9fa] p-4">
          <p className="text-[11px] font-normal leading-normal text-[#6e7b84]">
            Calculated total charges
          </p>
          <p className="text-[32px] font-semibold leading-normal text-[#202b33]">
            {view.finance.total}
          </p>
          <p className="text-[10px] font-normal leading-normal text-[#6e7b84]">
            {view.finance.currencyLabel}
          </p>
        </div>
        <div className="flex flex-col gap-[14px]">
          <p className="text-[10px] font-semibold leading-normal text-[#6e7b84]">
            RECORDED AMOUNTS
          </p>
          {view.finance.amounts.map((amount) => (
            <AmountRow key={amount.label} label={amount.label} value={amount.value} />
          ))}
        </div>
        <div className="h-px w-full bg-[#e2e7ea]" />
        <div className="flex flex-col gap-[14px]">
          <div className="flex items-center justify-between">
            <p className="text-[10px] font-semibold leading-normal text-[#6e7b84]">
              RATE SETTINGS
            </p>
            <StatusPill label={view.finance.rateMode} />
          </div>
          {view.finance.rates.map((rate) => (
            <AmountRow key={rate.label} label={rate.label} value={rate.value} />
          ))}
        </div>
        <p className="text-[10px] font-normal leading-[1.6] text-[#6e7b84]">
          Amounts shown as recorded. Rate units are not specified; these values are not
          an itemized reconciliation.
        </p>
      </WorkspaceCard>
      <WorkspaceCard className="flex flex-col gap-[17px] p-5">
        <div className="flex items-center justify-between">
          <h2 className="text-[15px] font-semibold leading-normal text-[#202b33]">
            Approval
          </h2>
          <StatusPill
            label={view.approval.label}
            tone={approved ? "approved" : rejected ? "priority" : "neutral"}
            dot
          />
        </div>
        <div className="flex flex-col gap-[6px]">
          <p className="text-[11px] font-normal leading-normal text-[#6e7b84]">
            Reviewed on
          </p>
          <p className="text-[12px] font-medium leading-normal text-[#202b33]">
            {view.approval.reviewedLabel}
          </p>
        </div>
        {view.approval.note ? (
          <div
            className={`flex items-start gap-2 rounded-[6px] p-3 ${
              approved ? "bg-[#eaf4f1]" : "bg-[#f7f9fa]"
            }`}
          >
            <JobWorkspaceIcon name="circleCheck" />
            <p
              className={`text-[11px] font-normal leading-[1.6] ${
                approved ? "text-[#167366]" : "text-[#6e7b84]"
              }`}
            >
              {view.approval.note}
            </p>
          </div>
        ) : null}
      </WorkspaceCard>
    </div>
  );
}
